import {
  ReportSection,
  ReportSectionConfigurationBase,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';
import { OrientationInstitutionsModel } from './orientation-institutions.model';

export class OrientationInstitutionsConfiguration extends ReportSectionConfigurationBase {
  typeName = 'OrientationInstitutionsConfiguration';
  nodataLocalizationKeyName = 'orientationInstitutions';
  readonly reportSection = ReportSection.OrientationInstitutions;
  readonly applicableReportTypes = [ReportType.OwnershipAnalyticsReport];
  readonly reportViewModelSections = [ReportViewModelSection.OwnershipAnalyticsReport_OrientationInstitutions];
  readonly minSize = 2;
  readonly maxSize = 4;
  readonly defaultSize = 4;
  readonly availableDataSections = [];

  get name(): string {
    if (this.appliedReportType === ReportType.OwnershipAnalyticsReport) {
      return 'orientationInstitutions';
    } else {
      throw new Error('Report Type not supported');
    }
  }

  get displayName(): string {
    if (this.appliedReportType === ReportType.OwnershipAnalyticsReport) {
      return 'Orientation';
    } else {
      throw new Error('Report Type not supported');
    }
  }
}

export interface OrientationInstitutionsData {
  [ReportViewModelSection.OwnershipAnalyticsReport_OrientationInstitutions]: OrientationInstitutionsModel;
}
